import { DRIVER_REGISTRATION } from "../../types";

export const driverRegAction =
  (data = {}) =>
  (dispatch) => {
    // dispatch({ type: DRIVER_REGISTRATION, payload: data });
    console.log(data);
  };
